import React, { useState } from 'react';
import { MdDeleteForever } from 'react-icons/md';
import { sendIdentityServiceAuthenticatedRequest } from 'services/AsyncRequestService';
import { getErrorMessage } from 'services/UtilityService';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { showNotification } from 'services/NotificationService';
import 'assets/css/user.css';

const DeleteUser = ({ userInfoId, handler }) => {
  const [errorMsg, setErrorMsg] = useState(null);
  const [asyncInProgress, setAsyncInProgress] = useState(false);

  const deleteUser = () => {
    setAsyncInProgress(true);
    sendIdentityServiceAuthenticatedRequest(
      `/users/${userInfoId}`,
      'DELETE',
      null,
      (r) => {
        setAsyncInProgress(false);
        showNotification({
          title: 'Action successful!',
          message: 'User deleted successfully.',
          position: 'tc',
          type: 'success',
        });

        handler();
      },
      (r) => {
        setAsyncInProgress(false);
        showNotification({
          title: 'Error!',
          message: getErrorMessage(r.data) || getErrorMessage('UNABLE_TO_DELETE_USER'),
          position: 'tc',
          type: 'error',
        });
      }
    );
  };

  return (
    <OverlayTrigger overlay={<Tooltip>Delete User</Tooltip>}>
      <MdDeleteForever
        className="user-action-button delete-user"
        size={20}
        onClick={() => {
          if (window.confirm('Are you sure you want to delete this user?')) {
            deleteUser();
          }
        }}
      ></MdDeleteForever>
    </OverlayTrigger>
  );
};

export default DeleteUser;
